import React from 'react';
import Invoice from '../components/Invoice';
import Layout from '../components/Layout';

export default function InvoicePage() {
  // Invoice data extracted from the PDF
  const invoiceData = {
    invoiceNumber: 'MJ/SS108',
    invoiceDate: '10-02-2026',
    dateOfSupply: '10-02-2026',
    poNumber: '302168',
    
    seller: {
      name: 'M&J ENTERPRISES',
      address: '1-B, Rajupalem, Ozili Mandalam, Tirupathi DIST.AP',
      gstin: '37ABMFM1108N1ZZ',
      state: 'AP',
      bankName: 'IDFC FIRST BANK GUDUR',
      accountNumber: '10077978168',
    },
    
    buyer: {
      name: 'SRI BALAJI CASTINGS PVT LTD',
      address: 'No.94,95,102,103, Sipcot Export Promotion Industrial park, Gummidipoondi, Thiruvallur-601201',
      gstin: '33AABCS4985J1Z1',
      state: 'TAMILNADU',
    },
    
    lineItems: [
      {
        serialNo: 1,
        description: 'Silica sand dry',
        quantity: 30240.00,
        unit: 'kgs',
        rate: 3.80,
        amount: 114912.00,
      }
    ],
    
    gstRate: 5,
    gstAmount: 5746.00,
    totalAmount: 120658.00,
    amountInWords: 'ONE LAKHS TWENTY THOUSAND SIX HUNDRED FIFTY EIGHT ONLY',
    
    transport: {
      mode: 'By Lorry',
      vehicleNumber: 'TN18AX9997',
    },
    
    reverseCharge: 'N',
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    // For now, trigger print dialog (which can save as PDF)
    // In production, you'd integrate a PDF generation library
    window.print();
  };

  return (
    <Layout>
      <div className="max-w-6xl mx-auto py-6">
        <Invoice 
          invoiceData={invoiceData}
          onPrint={handlePrint}
          onDownload={handleDownload}
        />
      </div>
    </Layout>
  );
}
